import { render } from "./UserManualTypeDetail.vue?vue&type=template&id=20fa1915"
import script from "./UserManualTypeDetail.vue?vue&type=script&lang=js"
export * from "./UserManualTypeDetail.vue?vue&type=script&lang=js"

import "./UserManualTypeDetail.vue?vue&type=style&index=0&id=20fa1915&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__